// AI Competitors data for HST

export const COMPETITORS = [
  {
    id: 'transnord',
    name: 'TransNord Express',
    slogan: 'Le Nord, c\'est nous.',
    color: '#1E40AF',
    logo: '/competitor-logos/transnord.webp',
    style: 'Agressif sur les prix, volume important',
    baseCa: 8000,
    growthRate: 0.03,
    baseFleet: 3,
    baseReputation: 45,
    baseDrivers: 4,
    specialties: ['Messagerie / Colis', 'Vrac/Palettes'],
    personality: 'agressif',
    avatar: 'TN',
    // 17/06/2026 (Lot 6 Phase 1.5) — Dirigeant fictif + micro-bio.
    // Sert au futur narratif (Phase 3 : messages d'OPA, fusion, etc.).
    director: {
      name: 'Ivan Kerthoud',
      role: 'PDG fondateur',
      bio: 'Patron du Nord à la poigne ferme. A bâti TransNord à coups de rachats hostiles depuis 2008. Réputé infréquentable mais redoutable en négociation.',
    },
    reactions: {
      playerGrows: "TransNord baisse ses prix de 5% pour rester compétitif.",
      playerStruggles: "TransNord rachète un de vos anciens contrats.",
      neutral: "TransNord poursuit son expansion dans le Nord.",
    },
  },
  {
    id: 'logistar',
    name: 'LogiStar International',
    slogan: 'L\'Europe sans frontières.',
    color: '#7C3AED',
    logo: '/competitor-logos/logistar.webp',
    style: 'Grand groupe, contrats EU premium',
    baseCa: 25000,
    growthRate: 0.015,
    baseFleet: 8,
    baseReputation: 62,
    baseDrivers: 10,
    specialties: ['Export UE', 'Frigo/Pharma'],
    personality: 'corporate',
    avatar: 'LS',
    director: {
      name: 'Geoffrey Romagnoli',
      role: 'Président du Directoire',
      bio: 'Ex-cadre dirigeant chez Géodis, recruté par le board en 2019. Diplomate, polyglotte, joue sa carrière sur l\'export EU. Très médiatisé.',
    },
    reactions: {
      playerGrows: "LogiStar surveille votre montée en puissance avec attention.",
      playerStruggles: "LogiStar propose une sous-traitance à tarif réduit.",
      neutral: "LogiStar signe un nouveau contrat EU avec un grand distributeur.",
    },
  },
  {
    id: 'ecoroute',
    name: 'ÉcoRoute Services',
    slogan: 'Transporter mieux, pas plus.',
    color: '#059669',
    logo: '/competitor-logos/ecoroute.webp',
    style: 'Petit mais en croissance, éco-responsable',
    baseCa: 4000,
    growthRate: 0.05,
    baseFleet: 2,
    baseReputation: 55,
    baseDrivers: 2,
    specialties: ['Messagerie / Colis', 'BTP / Matériaux'],
    personality: 'ecolo',
    avatar: 'ER',
    director: {
      name: 'Stéphane Nillet',
      role: 'Gérant-fondateur',
      bio: 'Ancien chauffeur PL devenu entrepreneur engagé. Première flotte 100% biométhane de la région. Adoré des médias locaux, méfiant des grands groupes.',
    },
    reactions: {
      playerGrows: "ÉcoRoute investit dans un véhicule électrique pour se démarquer.",
      playerStruggles: "ÉcoRoute vous propose un partenariat local.",
      neutral: "ÉcoRoute obtient le label GreenLogistics.",
    },
  },
  {
    id: 'rapidfret',
    name: 'Rapid\'Fret Solutions',
    slogan: 'Plus vite, toujours.',
    color: '#DC2626',
    logo: '/competitor-logos/rapidfret.webp',
    style: 'Messagerie, concurrent direct',
    baseCa: 6000,
    growthRate: 0.035,
    baseFleet: 3,
    baseReputation: 48,
    baseDrivers: 3,
    specialties: ['Messagerie / Colis', 'Messagerie express'],
    personality: 'speed',
    avatar: 'RF',
    director: {
      name: 'Ruddy Loumandé',
      role: 'CEO & Co-fondateur',
      bio: 'Ex-coureur cycliste pro reconverti. Obsédé par l\'optimisation des tournées et le temps. Communique uniquement par messages courts. Direct, parfois cassant.',
    },
    reactions: {
      playerGrows: "Rapid'Fret recrute un chauffeur expérimenté pour contre-attaquer.",
      playerStruggles: "Rapid'Fret récupère vos clients mécontents.",
      neutral: "Rapid'Fret optimise ses tournées avec un nouveau logiciel TMS.",
    },
  },
];

export const COMPETITION_EVENTS = [
  // 01/06/2026 — `comp-bid` (Appel d'offres disputé) removed in favour of
  // the full Tender / AO subsystem (slices/tenderSlice.js). The new system
  // is gated by commercial roles + fleet size + HSE compliance + multi-
  // factor probability scoring.
  {
    id: 'comp-poach', type: 'driver_poach', name: 'Tentative de débauchage',
    description: 'Un concurrent propose un meilleur salaire à l\'un de vos chauffeurs.',
    probability: 0.06, minDays: 30,
  },
  {
    id: 'comp-alliance', type: 'alliance_offer', name: 'Proposition d\'alliance',
    description: 'Un concurrent propose une collaboration ponctuelle.',
    probability: 0.05, minDays: 45,
  },
  {
    id: 'comp-bankruptcy', type: 'competitor_bankruptcy', name: 'Faillite d\'un concurrent',
    description: 'Un concurrent est en grande difficulté financière.',
    probability: 0.02, minDays: 120,
  },
  {
    id: 'comp-price-war', type: 'price_war', name: 'Guerre des prix',
    description: 'Un concurrent casse les prix sur votre marché principal.',
    probability: 0.08, minDays: 30,
  },
];

// Export contract abroad costs
export const ABROAD_COSTS = {
  hotel: { perDay: 85, label: 'Hôtel', icon: 'bed' },
  repas: { perDay: 35, label: 'Repas', icon: 'utensils' },
  divertissement: { perDay: 25, label: 'Divertissement', icon: 'sparkles' },
  peage: { perDay: 45, label: 'Péages internationaux', icon: 'road' },
  assurance: { perDay: 15, label: 'Assurance déplacement', icon: 'shield' },
};

export const getAbroadDailyCost = () => {
  return Object.values(ABROAD_COSTS).reduce((s, c) => s + c.perDay, 0);
};

export const simulateCompetitor = (competitor, totalDays, playerReputation, playerCa) => {
  const months = Math.floor(totalDays / 30);
  const growth = Math.pow(1 + competitor.growthRate, months);
  let reactionFactor = 1;
  if (playerCa > competitor.baseCa * growth * 1.5) reactionFactor = 1.15;
  if (playerReputation > competitor.baseReputation + 20) reactionFactor *= 0.95;
  const ca = Math.round(competitor.baseCa * growth * reactionFactor * (0.9 + Math.random() * 0.2));
  const fleet = Math.max(competitor.baseFleet, competitor.baseFleet + Math.floor(months / 6));
  const reputation = Math.min(95, Math.max(20, competitor.baseReputation + Math.floor(months * 0.3) + Math.floor(Math.random() * 5 - 2)));
  const drivers = Math.max(competitor.baseDrivers, competitor.baseDrivers + Math.floor(months / 4));
  return { ca, fleet, reputation, drivers };
};
